import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import { getTemplateAlerts, updateTemplateAlert, resendTemplateAlert } from '../../../redux/actions/searchAlertsAction';
import { formatUnixDate, getPeriodFromNow } from '../../../utils/dateFormat';
import { isCourtDrive } from '../../../util/globalUtils';
import { Loading } from '../../common/Loading';
import offButton from '../../../images/off_button_small.png';
import onButton from '../../../images/on_button_small.png';
import './TemplateAlerts.less';

export class TemplateAlerts extends Component {
  componentDidMount() {
    this.props.getAlerts();
  }

  onEnabledButtonClick = (index, oldValue, alert) => {
    this.props.updateAlert({
      index,
      name: 'enabled',
      value: !oldValue ? 1 : 0,
      alert,
    });
  };

  onIntervalSelectChange = (index, value, alert) => {
    this.props.updateAlert({
      index,
      name: 'notify_interval',
      value,
      alert,
    });
  };

  onResendButtonClick = (event, alert, index) => {
    event.preventDefault();
    this.props.resendTemplateAlert({ alert, index });
  };

  render() {
    const { alerts, isLoading } = this.props;

    return (
      <section>
        <h2 id="template-alerts" style={{ marginTop: '32px' }}>Template Alerts</h2>
        <table className="template-alerts-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Created</th>
              <th>Last executed</th>
              <th>Type</th>
              <th>Opt in/out</th>
              <th>Interval</th>
              <th colSpan="2">Operation</th>
            </tr>
          </thead>
          <tbody>
            {alerts.length === 0 || isLoading
              ? (
                <tr>
                  <td colSpan="100%">
                    {isLoading
                      ? <Loading show={isLoading} type="bar" />
                      : 'No templates available.'
                    }
                  </td>
                </tr>
              ) : (
                alerts.map((alert, index) => (
                  <tr key={alert.id}>
                    <td>
                      {alert.name}
                    </td>
                    <td>
                      {formatUnixDate(alert.created)}
                    </td>
                    <td>
                      {getPeriodFromNow(alert.last_execute)}
                    </td>
                    <td>
                      {alert.type_label}
                    </td>
                    <td>
                      {alert.customize_access
                        ?
                        alert.isUpdating && alert.isUpdating.enabled
                          ?
                            <Loading show={alert.isUpdating.enabled} type="spinner" />
                          :
                          <div
                            className="onoff-switch"
                            onClick={() => this.onEnabledButtonClick(index, alert.enabled, alert)}
                          >
                            <img src={alert.enabled ? onButton : offButton} alt="on/off switch" />
                          </div>
                        :
                          <div className="form-item">
                          <input
                            type="checkbox"
                            name="enabled"
                            checked={alert.enabled && 'checked'}
                            disabled="disabled"
                            className="form-checkbox" />
                        </div>
                      }
                    </td>
                    <td>
                      {alert.isUpdating && alert.isUpdating.notify_interval
                        ?
                          <Loading show={alert.isUpdating.notify_interval} type="spinner" />
                        :
                        <div className="interval-select">
                          <Select
                            options={alert.notify_interval_options}
                            value={alert.notify_interval}
                            onChange={({ value }) => this.onIntervalSelectChange(index, value, alert)}
                            clearable={false}
                            disabled={!alert.customize_access}
                          />
                        </div>
                      }
                    </td>
                    {alert.customize_access
                      ?
                        <Fragment>
                        <td>
                          <a href={alert.url}>Show</a>
                        </td>
                        <td>
                          {alert.isBeingResent
                            ?
                              <Loading show={alert.isBeingResent} type="spinner" />
                            :
                            (alert.resend || !alert.enabled)
                              ?
                                <a className="disabled">Resend</a>
                              :
                              <a href="#" onClick={e => this.onResendButtonClick(e, alert, index)}>
                                Resend
                              </a>
                          }
                        </td>
                      </Fragment>
                      :
                      <td colSpan="2">
                        <a
                          href={isCourtDrive()
                            ? 'https://www.courtdrive.com/pricing-plans.html'
                            : 'https://www.inforuptcy.com/pricing/investors'
                          }
                        >Upgrade
                        </a>
                      </td>
                    }
                  </tr>
                ))
              )
            }
          </tbody>
        </table>
        <div style={{ textAlign: 'right' }}>
          <small>
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); this.props.getAlerts(); }}
            >
              Refresh
            </a>
          </small>
        </div>
      </section>
    );
  }
}

TemplateAlerts.propTypes = {
  alerts: PropTypes.array,
  isLoading: PropTypes.bool,
  getAlerts: PropTypes.func,
  updateAlert: PropTypes.func,
  resendTemplateAlert: PropTypes.func,
};

TemplateAlerts.defaultProps = {
  alerts: [],
  isLoading: false,
  getAlerts: () => { },
  updateAlert: () => { },
  resendTemplateAlert: () => { },
};

const mapStateToProps = state => ({
  alerts: state.getIn(['templateAlerts', 'alerts']).toJS(),
  isLoading: state.getIn(['templateAlerts', 'isLoading']),
});

const mapDispatchToProps = {
  getAlerts: getTemplateAlerts,
  updateAlert: updateTemplateAlert,
  resendTemplateAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateAlerts);



// WEBPACK FOOTER //
// ./src/components/searchAlerts/TemplateAlerts/TemplateAlerts.jsx